import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loader from "../Layout/Loader";
import LayoutRoutes from "../routes/LayoutRoutes";
import PrivateRoute from "../routes/PrivateRoute";
import SignIn from "../features/auth/pages/SignIn";

/**
 * Tek BrowserRouter + Suspense kökü. Initial load Suspense fallback olarak
 * Loader gösterir (route component'leri lazy-loaded).
 *
 * Root (/) artık doğrudan dashboard'a düşer (routes/index.jsx'te tanımlı).
 * Legacy `/default/:layout` path'i hâlâ Default'a yönlenir;
 * eski deep-link'ler kırılmasın diye routes/index.jsx'te redirect var.
 */
const AppRouter = () => {
  return (
    <BrowserRouter basename="/">
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/login" element={<SignIn />} />
          {/* PrivateRoute layout (pathless) — auth gate, child catchall'a düşer */}
          <Route element={<PrivateRoute />}>
            <Route path="*" element={<LayoutRoutes />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRouter;
